import React from 'react'

const AVATAR_BASE_URL = 'https://hattrick.org'

const resolveAvatarUrl = imagePath => {
  if (!imagePath || typeof imagePath !== 'string') {
    return null
  }

  const trimmedPath = imagePath.trim()
  if (!trimmedPath) {
    return null
  }

  if (trimmedPath.startsWith('http://') || trimmedPath.startsWith('https://')) {
    return trimmedPath
  }

  if (trimmedPath.startsWith('/')) {
    return `${AVATAR_BASE_URL}${trimmedPath}`
  }

  return `${AVATAR_BASE_URL}/${trimmedPath}`
}

const PlayerAvatar = ({ avatar, size = 100 }) => {
  if (!avatar || !avatar.layers || avatar.layers.length === 0) {
    return null
  }

  // Hattrick avatar canvas is 110x155. We render at native size and
  // use CSS transform to scale the whole thing down to the requested size.
  const originalWidth = 110
  const originalHeight = 155
  const scale = size / originalHeight
  const backgroundUrl = resolveAvatarUrl(avatar.backgroundImage)

  return (
    <div
      style={{
        width: originalWidth * scale,
        height: originalHeight * scale,
        flexShrink: 0,
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'relative',
          width: originalWidth,
          height: originalHeight,
          transform: `scale(${scale})`,
          transformOrigin: 'top left',
        }}
      >
        {/* Background image */}
        {backgroundUrl && (
          <img
            src={backgroundUrl}
            alt=""
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: originalWidth,
              height: originalHeight,
            }}
          />
        )}
        {/* Layers — each placed at its native x/y, rendered at natural size */}
        {avatar.layers.map((layer, index) => {
          const layerUrl = resolveAvatarUrl(layer.image)
          if (!layerUrl) {
            return null
          }

          return (
            <img
              key={index}
              src={layerUrl}
              alt=""
              style={{
                position: 'absolute',
                left: layer.x,
                top: layer.y,
              }}
            />
          )
        })}
      </div>
    </div>
  )
}

export default PlayerAvatar
